import { Address, City } from '@app/types';
import axios, { AxiosRequestConfig } from 'axios';
import { SharedAddress } from './addresses-shared-api';

const api = axios.create({
  baseURL: 'https://form-api.cliqueiachei.com.br/form',
});

type APIFormResponse<ItemData> = {
  itens: APIFormResponseItem<ItemData>[];
};

type APIFormResponseItem<Data> =
  | {
      createdAt: string;
      data: Data;
      id: number;
    }
  | undefined;

export const APIForms = {
  get<T = any>(path: string, config?: AxiosRequestConfig) {
    return api.get<APIFormResponse<T>>(path, config);
  },
  post(path: string, data: any, config?: AxiosRequestConfig) {
    return api.post(path, data, config);
  },
  put(path: string, id: string | number, data: any) {
    return api.put(`${path}/${id}`, data);
  },
  delete(path: string, id: string) {
    return api.delete(`${path}/${id}`);
  },
  jsonPath<T>(path: string, query: string) {
    return api.get<T>(`${path}/json-path?filterExpression=${query}`);
  },
};

export class APIUserData {
  static async fetch(deviceId: string) {
    const response = await APIForms.get<UserDataResponse>(`/user-data-${deviceId}`);
    return response?.data?.itens[0];
  }
}

type ExtraData = {
  userDeviceId: string;
  savedByRestaurantId: string;
  savedByRestaurantName: string;
  lastUsageByRestaurantId: string;
  lastUsageByRestaurantName: string;
  lastUsageAt: number;
};

export function createSharedAddressFromAddress(address: Address, extraData: ExtraData): SharedAddress {
  return {
    ...address,
    landmark: address.landmark ?? '',
    number: address.number ?? '',
    userDeviceId: extraData.userDeviceId,
    lastUsageAt: extraData.lastUsageAt,
    lastUsageByRestaurantId: extraData.lastUsageByRestaurantId,
    lastUsageByRestaurantName: extraData.lastUsageByRestaurantName,
    savedByRestaurantId: extraData.savedByRestaurantId,
    savedByRestaurantName: extraData.savedByRestaurantName,
  };
}

export type DeliveryAddress = {
  city: City;
  complement: string;
  id: string;
  isMain: boolean;
  landmark: string;
  name: string;
  neighborhood: string;
  number: string;
  street: string;
};

type UserDataResponse = {
  address: DeliveryAddress | null;
};
